// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
// import Label from '../../../components/Label';
import SvgIconStyle from '../../../components/SvgIconStyle';
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const getOtherIcon = (name) => <Iconify icon={name} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getOtherIcon('ant-design:user-outline'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getOtherIcon('ant-design:dot-chart-outline'),
  dashboard: getIcon('ic_dashboard'),
  generalReviewed: getOtherIcon('ant-design:file-protect-outline'),
  settings: getOtherIcon('eva:settings-outline'),
  findPapers: getOtherIcon('ant-design:file-search-outline'),
  underReview: getOtherIcon('ant-design:highlight-outline'),
  pastReview: getOtherIcon('ant-design:container-outline'),
  submittedPapers: getOtherIcon('ant-design:file-sync-outline'),
  publishedPapers: getOtherIcon('ant-design:file-protect-outline'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'Papers with Reviews', path: PATH_DASHBOARD.general.papers, icon: ICONS.generalReviewed },
      { title: 'PeerXiv Statistics', path: PATH_DASHBOARD.general.stats, icon: ICONS.analytics },
      { title: 'Profile', path: PATH_DASHBOARD.general.profile, icon: ICONS.user },
      { title: 'Settings', path: PATH_DASHBOARD.general.settings, icon: ICONS.settings },
    ],
  },

  {
    subheader: 'Reviewer',
    items: [
      { title: 'Find Papers', path: PATH_DASHBOARD.reviewer.find, icon: ICONS.findPapers },
      { title: 'Active Reviews', path: PATH_DASHBOARD.reviewer.active, icon: ICONS.underReview },
      { title: 'Completed Reviews', path: PATH_DASHBOARD.reviewer.past, icon: ICONS.pastReview },
      { title: 'Reviewer Statistics', path: PATH_DASHBOARD.reviewer.stats, icon: ICONS.analytics },
    ],
  },

  {
    subheader: 'Author',
    items: [
      { title: 'Submitted Papers', path: PATH_DASHBOARD.author.submitted, icon: ICONS.submittedPapers },
      // { title: 'Under Review', path: PATH_DASHBOARD.general.analytics, icon: ICONS.underReview },
      { title: 'Reviewed Papers', path: PATH_DASHBOARD.author.reviewed, icon: ICONS.publishedPapers },
      { title: 'Author Statistics', path: PATH_DASHBOARD.author.stats, icon: ICONS.analytics },
    ],
  },
];

export default navConfig;
